'use client'
// import { formatDistance, parseISO } from 'date-fns'

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/fa' // Import Persian locale
import jalaliday from 'jalali-plugin-dayjs'
import {toast} from '@/components/ui'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import moment from 'moment-jalaali'
import timezone from 'dayjs/plugin/timezone'
import {Notification} from "@/components/ui/Notification";

dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(jalaliday)
dayjs.extend(timezone)
dayjs.locale('fa')

//import { differenceInDays } from 'date-fns/esm';

// We want to make this function work for both Date objects and strings (which come from Supabase)
// export const subtractDates = (dateStr1, dateStr2) =T 0
//differenceInDays(parseISO(String(dateStr1)), parseISO(String(dateStr2)));


export const checkPermissionsByUser = (permissions, userPermissions, requireAll = true) => {
    // alert(permissions.join(' '))
    permissions = permissions || []
    userPermissions = userPermissions || []
    permissions = Array.isArray(permissions) ? permissions : [permissions]
    if (permissions.length <= 0) return true
    userPermissions = Array.isArray(userPermissions) ? userPermissions : [userPermissions]
    // console.log('userPermissions:', userPermissions)
    if (requireAll)
        return permissions.every((permission) => userPermissions.includes(permission) || userPermissions.includes(permission?.value) || userPermissions.includes('*'))
    return permissions.some((permission) => userPermissions.includes(permission) || userPermissions.includes(permission?.value) || userPermissions.includes('*'))
}

export const reverse2DObject = (obj) => Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [value, key])
)

export const randomString = (length = 16) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let result = ''
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    return result
}

export function hexToArrayBuffer(hex) {
    if (hex.length % 2 !== 0) {
        throw new Error('Hex string must have an even number of characters')
    }
    const buffer = new ArrayBuffer(hex.length / 2)
    const view = new Uint8Array(buffer)
    for (let i = 0; i < hex.length; i += 2) {
        view[i / 2] = parseInt(hex.substr(i, 2), 16)
    }
    return buffer
}

// export const formatDistanceFromNow = (dateStr) =>
//     formatDistance(parseISO(dateStr), new Date(), {
//         addSuffix: true
//     })
//         .replace('about ', '')
//         .replace('in', 'In')

// Supabase needs an ISO date string. However, that string will be different on every render because the MS or SEC have changed, which isn't good. So we use this trick to remove any time
export const getToday = function (options = {}) {
    const today = new Date()

    // This is necessary to compare with created_at from Supabase, because it it not at 0.0.0.0, so we need to set the date to be END of the day when we compare it with earlier dates
    if (options?.end)
        // Set to the last second of the day
        today.setUTCHours(23, 59, 59, 999)
    else today.setUTCHours(0, 0, 0, 0)
    return today.toISOString()
}

export const formatCurrency = (value) =>
    new Intl.NumberFormat('en', {style: 'currency', currency: 'USD'}).format(
        value
    )

export function formatDuration(milliseconds) {
    const seconds = Math.floor((milliseconds || 0) / 1000)
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    return `${hours > 0 ? String(hours).padStart(2, '0') + ':' : ''}${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
}

export function shuffleArray(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]]
    }
    return arr
}

export function formatNumber(number) {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}


export function formatNumberWithUnit(number) {
    if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M'
    } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K'
    }

    return number
}

export function nl2br(str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

export function formatRelativeDate(timestamp, template = 'YYYY/MM/DD') {
    const date = dayjs(timestamp * 1000, {calendar: 'jalali'})
    const today = dayjs().startOf('day')
    const yesterday = dayjs().subtract(1, 'day').startOf('day')

    if (date.isSame(today, 'd')) {
        return 'امروز'
    } else if (date.isSame(yesterday, 'd')) {
        return 'دیروز'
    } else if (date.isAfter(today.subtract(6, 'day'))) {
        return `${today.diff(date, 'day') + 1} روز پیش`
    } else if (date.isAfter(today.subtract(1, 'week'))) {
        return 'هفته پیش'
    } else {
        return date.format(template)
    }
}

export function formatDateTime(timestamp, template = 'YYYY/MM/DD     HH:mm', fromTimezone = 'Asia/Tehran') {
    // console.log(timestamp)
    if (!timestamp || timestamp == 0) return null
    if (typeof timestamp === 'string')
        timestamp = dayjs(timestamp).unix()

    return dayjs
        .unix(timestamp)
        .tz(fromTimezone)
        .calendar('jalali')
        .format(template)

    // return dayjs.unix(timestamp).calendar('jalali').format(template)
    // let offset = dayjs(timestamp).tz(fromTimezone).utcOffset()
    // console.log(offset)
    // return dayjs.utc(dayjs.unix(timestamp).tz(fromTimezone).utc()).tz('Asia/Tehran').calendar('jalali').locale('fa').format(template)
    // return dayjs.unix(timestamp).utc().add(offset, 'minute').calendar('jalali').format(template)
    // return dayjs.unix(timestamp).tz(fromTimezone).calendar('jalali').format(template)

    // return dayjs
    //     .unix(timestamp)       // Interpret as UTC timestamp
    //     .tz(fromTimezone)     // Convert to Tehran timezone
    //     .calendar('jalali')   // Apply Jalali calendar
    //     .locale('fa')         // Optional: Farsi language for localization
    //     .format(template)     // Format as requested

}

export function formatBytes(bytes) {
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
    if (bytes === 0) return '0B'
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + sizes[i]
}

export function formatDistance(distance) {
    const sizes = [' متر', ' کیلومتر']
    if (isNaN(distance)) return distance
    const i = Math.floor(Math.log(distance) / Math.log(1000))
    return parseFloat((distance / Math.pow(1000, i)).toFixed(2)) + sizes[i]
}

export function jsonClone(object) {
    return JSON.parse(JSON.stringify(object))
}

export function isDateToday(dateToCheck) {
    const today = new Date()
    const providedDate = new Date(dateToCheck)

    return (
        today.getDate() === providedDate.getDate() &&
        today.getMonth() === providedDate.getMonth() &&
        today.getFullYear() === providedDate.getFullYear()
    )
}

export function shareUrl({title, url}) {
    if (window?.navigator?.share)
        return navigator.share({
            title,
            text: title,
            url
        })

    if (!window?.navigator.clipboard)
        return toast.push(<Notification type="danger" title={'خطا در اشتراک گذاری!'}/>)

    navigator.clipboard.writeText(url)
        .then(() => {
            toast.push(<Notification type="success" title={'لینک در کلیپ‌بورد کپی شد.'}/>)
        })
        .catch((error) => {
            toast.push(<Notification type="danger" title={'خطا در اشتراک گذاری!'}/>)
            console.error(error)
        })
}

export function showNotification({
                                     title,
                                     body,
                                     image,
                                     icon = null,
                                     actions = [],
                                     silent = false,
                                     vibrate = true,
                                     data = {}
                                 }) {
    if ('Notification' in window) {
        if (window.Notification.permission === 'granted') {
            navigator.serviceWorker.ready.then(registration => {
                registration.showNotification(title, {
                    body,
                    icon,
                    actions,
                    image,
                    silent,
                    vibrate,
                    data
                })
            })
        }
        /*else if (window.Notification.permission !== 'granted') {
            Notification.requestPermission().then(permission => {
                if (permission === 'granted') {
                    showNotification({title, body, image, icon, actions, silent, vibrate, data});
                }
            });
        }*/
    }
}

export const importKey = async (format, keyData, algorithm, extractable, usages) => {
    if (window.crypto && window.crypto.subtle) {
        return await window.crypto.subtle.importKey(format, keyData, algorithm, extractable, usages)
    } else {
        throw new Error('Web Crypto API is not supported in this environment')
    }
}

export const decrypt = async (data, key, iv) => {
    if (window.crypto && window.crypto.subtle) {
        try {
            return await window.crypto.subtle.decrypt({name: 'AES-CBC', iv}, key, data)
        } catch (error) {
            console.error('Error decrypting data:', error.stack)
            throw error // Rethrow the error to propagate it to the caller
        }
    } else {
        throw new Error('Web Crypto API is not supported in this environment')
    }
}

export const exportToExcel = ({data, fields = [], fileName, hiddenColumns = []}) => {
    const exportData = data.map(item => {
        const newItem = {}

        for (let field of Object.values(fields)) {
            if (
                // item.hasOwnProperty(field.name) &&
                field.export &&
                !hiddenColumns.includes(field.name))
                newItem[field.label] = field?.exportFn?.(item) || item[field.name]

            if (field.hasOwnProperty('subfields'))
                for (let subfield of Object.values(field.subfields?.() || []))
                    if (
                        // item[field.name]?.hasOwnProperty(subfield.name) &&
                        subfield.export &&
                        !hiddenColumns.includes(`${field.name}.${subfield.name}`))
                        newItem[`${field.label} - ${subfield.label}`] = subfield?.exportFn?.(item?.[field.name]) || item?.[field.name]?.[subfield.name]
        }

        return newItem
    })

    const worksheet = XLSX.utils.json_to_sheet(exportData)

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet)

    const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
    const dataBlob = new Blob([excelBuffer], {type: 'application/octet-stream'})
    saveAs(dataBlob, fileName || `${document.title} - ${dayjs().calendar('jalali').format('YYYY-MM-DD')}.xlsx`)
}

export function debounce(func, delay) {
    let timeout
    return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => func(...args), delay)
    }
}

export const formatAge = (birthDate, at = null, short = false) => {
    at = at == null ? moment().unix() : at
    at = moment.unix(at).startOf('day')
    birthDate = moment.unix(birthDate).startOf('day')

    let months = Math.abs(birthDate.diff(at, 'months'))
    let years = Math.floor(months / 12)
    months -= years * 12
    if (years > 0)
        return short ? `${years} سال` : `${years} سال و ${months} ماه`
    return `${months} ماه`
}


export function calculateAge(birthDate, at = null) {
    at = at == null ? moment().unix() : at
    at = moment.unix(at).startOf('day')
    birthDate = moment.unix(birthDate).startOf('day')
    // const today = moment().startOf('day');
    return Math.abs(birthDate.diff(at, 'years'))
}

export function formatTime(value, showSeconds = true) {
    // const timezoneOffsetInMinutes = dayjs().utcOffset()
    //
    // // Adjust the value with the timezone offset in seconds
    // value = value + timezoneOffsetInMinutes * 60

    // Calculate hours, minutes, and seconds
    const hh = Math.floor(value / 3600)
    const mm = Math.floor((value % 3600) / 60)
    const ss = value % 60

    let formattedTime = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
    if (showSeconds)
        formattedTime += `:${String(ss).padStart(2, '0')}`
    return formattedTime
}

export function convertTimeToValue(date) {
    if (!date) return null;
    // console.log(date)
    // const timezoneOffset = dayjs().utcOffset()* 60

    const newDate = dayjs(date)

    // console.log(newDate.format("HH:mm:ss"), newDate.hour() * 3600 + newDate.minute() * 60 + newDate.second() )

    return newDate.hour() * 3600 + newDate.minute() * 60 + newDate.second()
}

export function convertTimeToDate(value) {
    const referenceDate = dayjs.utc('1970-01-01T00:00:00Z')

    // const referenceDate = dayjs().calendar('jalali').startOf('day')

    const timezoneOffset = dayjs().utcOffset() * 60
    // Add the value (in seconds) to the reference date
    const resultDate = referenceDate.add(value - timezoneOffset, 'second')
    // console.log(resultDate.toDate())
    return resultDate.toDate() // Convert back to JavaScript Date object
}

export function openMap(location, label = '') {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    const mapUrl = `https://www.google.com/maps?q=${location}`
    if (isMobile) {
        // Use the geo URI for mobile devices
        const geoURI = `geo:${location}?q=${location}(${encodeURIComponent(label)})`
        try {
            window.open(geoURI)
        } catch (e) {
            window.open(mapUrl, '_blank')
            console.error(e)
        }
    } else {
        window.open(mapUrl, '_blank')
    }
}

export function formatPriceToman(amount) {
    if (isNaN(amount) || amount === '') return ''

    return new Intl.NumberFormat('fa-IR', {
        style: 'decimal', // No currency symbol for Toman
        minimumFractionDigits: 0
    }).format(amount) + ' تومان'
}

export function trimSlash(path) {
    path = path?.endsWith('/') ? path?.slice(0, -1) : path
    path = path?.startsWith('/') ? path?.slice(1) : path
    return path
}

export function parseDate(date) {
    if (typeof date == 'number') {
        date = new Date(Date.UTC(0, 0, date - 1)) // Excel epoch
        // return date.toISOString().split('T')[0].replace(/-/g, '/'); // → 'YYYY/MM/DD'
    }

    if (date instanceof Date)
        date = dayjs(date).calendar('jalali').format('YYYY/MM/DD')

    if (!date) return null
    date = date?.trim()
    const isJalali = /^\d{1,4}\/\d{1,2}\/\d{1,2}$/.test(date) && parseInt(date.split('/')[0]) < 1500
    const parsedDate = isJalali
        ? dayjs(date, {jalali: true}).calendar('jalali')
        : dayjs(date) // Assume Gregorian if not Jalali
    //
    // console.log(isJalali);
    // console.log(dayjs(dateString).format('YYYY-MM-DD'));
    // if (!parsedDate.isValid()) {
    //     throw new Error(`Invalid date: ${dateString}`);
    // }

    return {
        calendar: isJalali ? 'Jalali' : 'Gregorian',
        unix: isJalali ? dayjs(parsedDate, {jalali: true}).calendar('jalali').unix() : parsedDate.unix()
    }
}

export function persianDigits(input) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
    return (String(input)).replace(/\d/g, digit => persianDigits[digit])
}

export const normalizeFilters = (data, filters) => {
    let normalizedData = {...data}

    for (let filter of Object.values(filters)) {
        try {
            if (!data.hasOwnProperty(filter.name)) continue

            let filterFn = (value) => value
            if (filter.type == 'select' || filter.type == 'component-select') {
                if (filter.filterMultiple)
                    filterFn = (options) => options?.map(option => option.hasOwnProperty('value') ? option.value : option?.id || option)
                else
                    filterFn = (option) => option.hasOwnProperty('value') ? option.value : option?.id || option
            } else if (filter.type == 'component')
                filterFn = (value) => value?.id

            if (filter.filterFn)
                filterFn = filter.filterFn

            normalizedData[filter.name] = filterFn ? filterFn(data[filter.name]) : data[filter.name]
            // console.log(`${filter.name} converted to `, normalizedData[field.name])
        } catch (e) {
            console.error(`Error converting filter ${filter.name}, data: `, data[filter.name], e.message)
        }
    }

    return normalizedData
}

export const normalizeFormData = (data, fields) => {
    let normalizedData = {...data}

    for (let field of Object.values(fields)) {
        try {
            if (!data.hasOwnProperty(field.name)) continue

            let formFn = (value) => value
            if (field.type == 'select' || field.type == 'component-select') {
                if (field.formMultiple)
                    formFn = (options) => options?.map(option => option.hasOwnProperty('value') ? option.value : option?.id || option)
                else
                    formFn = (option) => option.hasOwnProperty('value') ? option.value : option?.id || option
            } else if (field.type == 'component')
                formFn = (value) => value?.id

            if (field.formFn)
                formFn = field.formFn

            let value = data[field.name]
            let key = field.formKey || field.name
            if (key !== field.name)
                delete normalizedData[field.name]

            normalizedData[key] = formFn ? formFn(value) : data[value]
            // console.log(`${field.name} converted to `, normalizedData[key])
        } catch (e) {
            console.error(`Error converting field ${field.name}, data: `, data[field.name], e.message)
        }
    }

    return normalizedData
}

export const toPersianDigits = (str) => {
    return str?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
}

export const toEnglishDigits = (str) => {
    if (!str) return str
    const persianDigits = '۰۱۲۳۴۵۶۷۸۹'
    const arabicDigits = '٠١٢٣٤٥٦٧٨٩'
    return str.toString().replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (d) => {
        const index = persianDigits.indexOf(d)
        if (index > -1) return index
        return arabicDigits.indexOf(d)
    })
}

export const base64ToFile = (base64, fileName) => {
    const arr = base64.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], fileName, {type: mime})
}

export function getExtension(filePath) {
    return filePath?.slice(((filePath?.lastIndexOf('.') - 1) >>> 0) + 1).toLowerCase()
}


export function resizeImage(file, maxWidth = 1024) {
    return new Promise((resolve, reject) => {
        const img = new Image()
        const reader = new FileReader()

        reader.onload = (e) => {
            img.src = e.target.result
        }

        img.onload = () => {
            const canvas = document.createElement('canvas')
            let {width, height} = img

            // console.log(width, maxWidth)
            if (width > maxWidth) {
                height = (maxWidth / width) * height
                width = maxWidth
            }

            canvas.width = width
            canvas.height = height

            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(new File([blob], file.name, {type: file.type}))
                } else {
                    reject(new Error('Canvas is empty'))
                }
            }, file.type)
        }

        img.onerror = (err) => reject(err)
        reader.onerror = (err) => reject(err)

        reader.readAsDataURL(file)
    })
}

export const ibanIsSepah = (iban) => {
    if (!iban) return false;
    iban = iban.replace(/\s+/g, '').toUpperCase();
    return (
        // iban.startsWith('IR') &&
        // iban.length === 24 &&
        iban.substring(2, 6) === '0150'
    );
};

export const parseKeyValueString = (input) => {
    // Match "something : number" with English + Persian letters/digits
    const regex = /([\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9A-Za-z0-9\s]+)\s*:\s*([\u06F0-\u06F90-9]+)/g;
    const result = {};

    let match;
    while ((match = regex.exec(input)) !== null) {
        let key = match[1].trim()
        // .replace(/\s+/g, ""); // remove spaces
        let rawValue = match[2];

        // Convert Persian/Arabic digits to English
        const value = Number(
            rawValue.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, d =>
                "۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩".indexOf(d) % 10
            )
        );

        result[key] = value;
    }

    return result;
}


const persianFixedHolidays = ['01/01', '01/02', '01/03', '01/04', '01/12', '01/13', '03/14', '03/15', '11/22', '12/29']
// const hijriFixedHolidays = ['01/09', '01/10', '02/20', '02/28', '02/30', '03/08', '03/17', '06/03', '07/13', '07/27', '08/15', '09/21', '10/01', '10/02', '10/25', '12/10', '12/18']
// const persianHijriDifference = {
//     '1403': -1,
//     '1404': -1
// }


const hijriHolidays = [
    '1404/01/02', '1404/01/11', '1404/01/12', '1402/02/04', '1404/03/16', '1404/03/24', '1404/04/14', '1404/04/15', '1404/05/23', '1404/05/31', '1404/06/02', '1404/06/10', '1404/06/19', '1402/09/03', '1404/10/13', '1404/10/27', '1404/11/15', '1404/12/20',
]

export const isHoliday = (date, {includeFriday = true} = {includeFriday: true}) => {
    if (includeFriday && dayjs(date).calendar('jalali').day() == 5)
        return true

    const shamsiDate = dayjs(date).calendar('jalali').format('MM/DD')
    const isPersianHoliday = persianFixedHolidays.includes(shamsiDate)
    // const hijriDate = momentHijri(date).add(persianHijriDifference[dayjs(date).calendar('jalali').format('YYYY')] || 0, 'day').format('iMM/iDD')
    // const isHijriHoliday = hijriFixedHolidays.includes(hijriDate)
    const isHijriHoliday = hijriHolidays.includes(dayjs(date).calendar('jalali').format('YYYY/MM/DD'))

    // console.log(shamsiDate, hijriDate, isPersianHoliday || isHijriHoliday);
    return isPersianHoliday || isHijriHoliday
}

export function scrollTo(container, target, offset = 0) {
    if (!container || !target) return;

    const containerTop = container?.getBoundingClientRect()?.top;
    const targetTop = target?.getBoundingClientRect()?.top;

    const scrollPosition = container?.scrollTop + (targetTop - containerTop) + offset;

    container?.scrollTo({
        top: scrollPosition,
        behavior: "smooth"
    });
}


export function calcSaraneOfGuest(row) {
    if (row?.contentType == "hotelsReservation") {
        if (row.guest?.contentType == "employeesRelative") {
            if (row?.hotelsItinerary?.hotel?.city?.name == "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 2)
                return 0
            else if (row?.hotelsItinerary?.hotel?.city?.name != "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 1)
                return 0
        }
        return row?.saraneCredit / (row.guests?.filter(guest => (guest?.contentType == "employee" || [1, 2, 3, 4, 5, 6].includes(guest?.relation)))?.length || 1)
    }

    if (row?.contentType == "toursReservation") {
        if (row.guest?.contentType == "employeesRelative") {
            if (row?.hotels[0]?.city?.name == "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 2)
                return 0
            else if (row?.hotels[0]?.city?.name != "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 1)
                return 0
        }
        return row?.saraneCredit / (row.guests?.filter(guest => (guest?.contentType == "employee" || [1, 2, 3, 4, 5, 6].includes(guest?.relation)))?.length || 1)
    }

    if (row?.contentType == "accommodationsReservation") {
        if (row.guest?.contentType == "employeesRelative") {
            if (row?.accommodationsItinerary?.hotel?.city?.name == "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 2)
                return 0
            else if (row?.accommodationsItinerary?.hotel?.city?.name != "مشهد" && calculateAge(row?.guest.birthDate, row?.enterDate) <= 1)
                return 0
        }
        return row?.saraneCredit / (row.guests?.filter(guest => (guest?.contentType == "employee" || [1, 2, 3, 4, 5, 6].includes(guest?.relation)))?.length || 1)
    }
}

export function calcSaranePercentageOfGuest(row) {
    if (row.guest?.contentType == "employeesRelative") {
        if ([1, 4].includes(row?.guest?.relation))
            return 0.22
        else if ([2, 3].includes(row?.guest?.relation))
            return row?.booker?.relatives?.some(item => [1, 4].includes(item.relation)) ? 0.5 : 0.22
        else if ([5, 6].includes(row?.guest?.relation))
            return 0.5
        else
            return 0
    }
    return 0.22
}

export const addQueryParam = (url, key, value) => {
    const newUrl = new URL(url, window.location.origin); // base for relative URLs
    newUrl.searchParams.set(key, value);
    return newUrl.toString();
};


export const isDivVisible = (div, container = window) => {
    const rect = div.getBoundingClientRect();

    if (!container) container = window;
    const containerRect = container.getBoundingClientRect();

    // const windowHeight = containerRect.height;
    const windowWidth = containerRect.width;


    return (
        // rect.top >= 0 &&
        rect.left >= 0 &&
        // rect.bottom <= windowHeight &&
        rect.right <= windowWidth
    );
};

export function postRedirect(url, data = {}) {
    if (!url) return;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;

    Object.entries(data || {}).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value ?? '';
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
}

export function copyToClipboard(text) {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        resolve();
    });
}
